import { createContext } from 'react-router';
import { UserData } from '../../types';

export const LoginContext = createContext<UserData>({});
